import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteParcours } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useDeleteParcours() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteParcours(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
    },
  });
}
